import { TileRoleRoute } from '@/types'
import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'

export const EstPianoMantenimentoRoute: TileRoleRoute = {
  path: 'estpianomantenimento',
  text: 'Piano Mantenimento Est.',
  faIcon: faScrewdriverWrench,
  element: (
    <ManagementGridFactory
      entity="est_piano_mantenimento"
      referencesCollection={'licenze_est'}
      referencesTitle="Piani mantenimento licenze Est."
      displayField="id"
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Piano Mantenimento Est.',
      icon: faScrewdriverWrench,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
